export default __webpack_public_path__ + "static/N0139-0e394249425fb9c27060dd1d42339aa7.png";